import { deserialize, serializable } from 'serializr';

export class TrelloProjectModel {
  @serializable
  public close: boolean;
  @serializable
  public shortLink: string;
  @serializable
  public id: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TrelloProjectModel, input));
  }
}
